import EditIcon from '@mui/icons-material/Edit';
import React from 'react';

function NoForms() {
  return (
    <div className="no-forms">
      <div className="edit-icon circle-icon">
        <EditIcon />
      </div>
      <div className="primary">No Forms have been created yet!</div>
      <div>Use the button below to create your first form.</div>
    </div>
  );
}

export { NoForms };
